package com.appsyde.shared.presentation.screen.component.ticket

/**
 * Données d'affichage d'une ligne ticket (liste).
 * summary et subtitleItems sont alignés sur computeHeaderTitle / computeHeaderSubtitle (RespondCardHeader).
 * operationalState* + problemBadge + missingBadges + lastMessageFrom = structure "piloter" (vue Tickets).
 */
data class TicketRowUi(
    val ticketId: String,
    val status: String,
    val summary: String,
    val subtitleItems: List<String> = emptyList(),
    val client: String,
    val age: String,
    val intent: String,
    val intentIcon: String,
    val priority: String,
    val missingCount: Int,
    val confirmCount: Int,
    val unread: Boolean,
    val missingPillText: String? = null,
    val confirmPillText: String? = null,

    /** État opérationnel (Ligne 2) : "À traiter", "En attente client", "Prêt à clôturer", "En traitement remboursement" */
    val operationalStateLabel: String = "À traiter",
    /** Style pill : "action" | "waiting" | "ready" | "refund" */
    val operationalStateKind: String = "action",
    /** Badge problème factuel (issue_type mappé), ex. "Produit cassé" */
    val problemBadge: String? = null,
    /** Max 2–3 badges "Manque : X" */
    val missingBadges: List<String> = emptyList(),
    /** "Vous" | "Client" pour Ligne 4 (optionnel) */
    val lastMessageFrom: String? = null,

    /** Règles métier (front only) : label texte pour la ligne secondaire, ex. "À traiter", "En attente client depuis 2 jours" */
    val businessStatusLabel: String = "À traiter",
    /** Clé couleur : "traite" | "a_traiter_neutral" | "a_traiter" | "a_verifier" | "en_attente_client" */
    val businessStatusColorKey: String = "a_traiter",
    /** false quand le label contient déjà "depuis X jours" (ageDays >= 1 et ticket ouvert) → ne pas afficher la date relative à côté */
    val showRelativeAge: Boolean = true,

    /** true quand l'extract IA est PENDING ou RUNNING → afficher la pill "Analyse en cours" */
    val extractInProgress: Boolean = false,

    /** V1 Assignment : nom du responsable (affiché en pill à la fin de la ligne) */
    val assigneeDisplayName: String? = null,

    /** Variant visuel ligne : "mine" (à moi), "free" (libre), "other" (assigné à un autre) */
    val rowVariant: String = "free"
)
